module.exports = __webpack_public_path__ + "static/brunswick-yard-274a4d6589d9d012940aa72db93cb0ce.jpg";